var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as App from '../../app';
import { DIV, SELECT } from '../../lib/dom';
import { BlueButton, CheckBox, OrangeButton } from '../../lib/components';
import { CustomModal } from '../CustomModal';
import { t, PHRASES, getLang, setLang } from '../../translate';
import { addUser } from '../../svg';
import './SettingsModal.less';
var INVITE_FRIENDS_FEATURE = FOR_VK;
var NEW_GAME_BTN_FEATURE = true;
var SettingsModal = /** @class */ (function (_super) {
    __extends(SettingsModal, _super);
    function SettingsModal(props) {
        var _this = _super.call(this, props, 'SettingsModal Modal_flex Modal_blue') || this;
        _this.name = 'SettingsModal';
        _this.maxBodyHeight = FOR_YANDEX ? 330 : 470;
        _this.deltaBodyHeight = 100;
        _this.onChangeMuteCheckbox = function (checked) {
            App.storage.upd({ mute: !checked });
            App.sounds.click();
        };
        _this.onChangeComboAnimationsCheckbox = function (checked) {
            App.storage.upd({ comboAnimations: checked });
            App.sounds.click();
        };
        _this.onChangeCancelMoveCheckbox = function (checked) {
            App.storage.upd({ cancelMove: checked });
            _this.props.onChangeCancelMoveFeature();
            App.sounds.click();
        };
        _this.onChangeColorTheme = function (value) {
            _this.props.onChangeColorTheme(value);
        };
        _this.onChangeLanguage = function (lang) {
            setLang(lang);
            App.emitter.emit('lang', lang);
            App.storage.upd({ lang: lang });
        };
        return _this;
    }
    SettingsModal.prototype.getContent = function () {
        var _this = this;
        return [
            (this.body = this.DIV({ className: 'scrollbar' }, [
                this.DIV('&__header', t(PHRASES.Settings)),
                Row([
                    Label([t(PHRASES.Sound_Effects)]),
                    new CheckBox({
                        className: 'mute',
                        checked: !App.storage.get().mute,
                        onChange: this.onChangeMuteCheckbox,
                    }),
                ]),
                Row([
                    Label([t(PHRASES.ComboAnimations)]),
                    new CheckBox({
                        className: 'comboAnimations',
                        checked: App.storage.get().comboAnimations,
                        onChange: this.onChangeComboAnimationsCheckbox,
                    }),
                ]),
                App.features.CANCEL_MOVE_FEATURE
                    ? Row([
                        Label([t(PHRASES.CancelMoveFeature)]),
                        new CheckBox({
                            className: 'cancelMove',
                            checked: App.storage.get().cancelMove,
                            onChange: this.onChangeCancelMoveCheckbox,
                        }),
                    ])
                    : null,
                IS_ULTRA
                    ? null
                    : this.DIV('Row Row_theme', [
                        Label([t(PHRASES.Color_Theme)]),
                        new SELECT({ onChange: this.onChangeColorTheme, value: App.themes.get().name }, [
                            { text: t(PHRASES.theme_default), value: 'default' },
                            { text: t(PHRASES.theme_old_school), value: 'old-school' },
                            { text: t(PHRASES.theme_night), value: 'night' },
                            { text: t(PHRASES.theme_instagram), value: 'instagram' },
                            { text: t(PHRASES.theme_green_lantern), value: 'green-lantern' },
                            { text: t(PHRASES.theme_white), value: 'white' },
                        ]),
                    ]),
                FOR_YANDEX ? null : Row([Label([t(PHRASES.Language)]), langSelect(getLang(), this.onChangeLanguage)]),
                App.features.DAILY_BONUS_FEATURE
                    ? new OrangeButton({ className: 'DailyBonusBtn', onClick: function () { return _this.props.onClickDailyBonus(); } }, [
                        t(PHRASES.DailyBonus),
                    ])
                    : null,
                new OrangeButton({ onClick: function () { return _this.props.onClickGlobalRating(); } }, [t(PHRASES.Global_Rating)]),
                INVITE_FRIENDS_FEATURE && Boolean(this.props.friendsRating)
                    ? this.DIV('&__friends', [
                        new BlueButton({ onClick: this.props.onClickFriendsRating }, [t(PHRASES.Friends_achievements)]),
                        new OrangeButton({ className: this.parseClassName('&__inviteBtn'), onClick: this.props.onClickInviteBtn }, [
                            addUser,
                        ]),
                    ])
                    : null,
                NEW_GAME_BTN_FEATURE ? new BlueButton({ onClick: this.props.onClickReplyBtn }, [t(PHRASES.New_Game)]) : null,
                this.DIV('&__version', "".concat(t(PHRASES.VERSION), ": ").concat(PACKAGE_VERSION, " / ").concat(BUILD_DATE)),
            ])),
        ];
    };
    return SettingsModal;
}(CustomModal));
export { SettingsModal };
function langSelect(lang, onChange) {
    return new SELECT({ onChange: onChange, value: lang }, IS_ULTRA
        ? [
            { text: t(PHRASES.lang_ru), value: 'ru' },
            { text: t(PHRASES.lang_en), value: 'en' },
        ]
        : [
            { text: t(PHRASES.lang_ru), value: 'ru' },
            { text: t(PHRASES.lang_en), value: 'en' },
            { text: t(PHRASES.lang_tr), value: 'tr' },
            { text: t(PHRASES.lang_es), value: 'es' },
            { text: t(PHRASES.lang_de), value: 'de' },
            { text: t(PHRASES.lang_hi), value: 'hi' },
        ]);
}
var Row = function (content) { return new DIV('Row', content); };
var Label = function (content) { return new DIV('Label', content); };
